import React from 'react';

function NoTestResult() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Test Result Found</p>
			</div>
		</div>
	);
}
export default NoTestResult;
